<template>
  <div class="tb cor-primaria-border cor-primaria-text">
    <div class="tb-fill">
      <div class="text-bold">{{titulo}}</div>
      <div>{{descricao}}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TituloDestacado",
  props: ["titulo", "descricao"]
};
</script>

<style scoped>

.text-bold{
  /*font-size: 0.9rem;*/
}

.tb {
  background-color: #f2f2f2;
  border: 1px solid;
}
.tb.lb-grupo > div {
  font-size: 1.2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/TituloDestacado.vue